import { createContactOrderSelectionState } from "../../../_logic/selection-state"
import type { ContactOrderPostalSelection } from "../../../../../../api/kehrblatt/contact-orders"

/** One organization-bound draft owned by the overlay, not by a mounted step. */
export class ContactOrderPlanningDraft {
  readonly organizationId: string
  selectionState = $state(createContactOrderSelectionState())
  removedEventIds = $state<string[]>([])
  // Only inactive choices live here. Active choices remain in selectionState.
  inactivePostalSelections = $state<Record<string, ContactOrderPostalSelection>>({})
  private readonly operationIds = new Map<string, string>()

  constructor(organizationId: string, removedEventIds: string[] = []) {
    this.organizationId = organizationId
    this.removedEventIds = [...removedEventIds]
  }

  operationIdFor(workOrderId: string, eventId: string | null | undefined): string {
    const key = JSON.stringify([workOrderId, eventId ?? null])
    let id = this.operationIds.get(key)

    if (!id) {
      id = crypto.randomUUID()
      this.operationIds.set(key, id)
    }

    return id
  }
}

export const createContactOrderPlanningDraft = (organizationId: string) =>
  new ContactOrderPlanningDraft(organizationId)
